<template>
  <div class="">
    <template v-if="type === 'round'">
      <div class="round-tag-title" :class="{required}">{{ title }}</div>
    </template>
    <template v-if="type === 'triangle'">
      <div class="triangle-tag u-flex">
        <div class="triangle-tag-title" :class="{'ordinary': score}">{{ title }}</div>
        <div class="triangle-tag-subtitle">
          <slot name="subtitle"></slot>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: "",
    },
    required: {
      type: Boolean,
      default: true
    },
    type: {
      type: String,
      default: "round"
    },
    score: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style lang="scss" scoped>
.round-tag-title {
  background-color: #197aff;
  border-radius: 8px;
  color: #fff;
  font-weight: 600;
  font-size: 16px;
  padding: 8px 18px;

  &.required::before {
    content: "*";
    font-size: 18px;
    color: #ff0000;
    position: absolute;
    left: 6px;
    top: 70%;
    transform: translateY(-70%);
  }
}

.triangle-tag {
  &-title {
    border-radius: 6px;
    color: #fff;
    font-weight: 600;
    font-size: 18px;
    padding: 8px 24px;
    margin-right: 10px;
    background: center/cover url(@/assets/images/progress_1.png) no-repeat;

    &.ordinary {
      background-image: url(@/assets/images/progress_2.png);
    }
  }

  &-subtitle {
    font-size: 16px;
    font-weight: 600;
  }
}
</style>